import { useDocumentTitle } from 'usehooks-ts';
import { Invitation } from 'referral/components';
import { useParams } from 'react-router';
import { useGetCouponQuery } from 'drycut-graphql';
import { Loader } from 'ui-components';

export function ReferralInvitation(): React.ReactElement {
  useDocumentTitle('DRYCUT - Referral');

  const { code } = useParams() as { code: string };
  const { data, loading } = useGetCouponQuery({ variables: { code } });

  if (loading) {
    return <Loader />;
  }

  return <Invitation coupon={data?.coupon} />;
}
